var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscalaVig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #6f6f73;\r\n      }\r\n\r\n      .st2 {\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .st2, .st3 {\r\n        fill: none;\r\n      }\r\n\r\n      .st4 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st3 {\r\n        stroke: #ddd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tooltip"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1856"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 350,
    width: 140,
    height: 106,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 350.5,
    y: 0.5,
    width: 139,
    height: 105,
    rx: 9.5,
    ry: 9.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1855"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 248,
    width: 97,
    height: 106,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 248.5,
    y: 0.5,
    width: 96,
    height: 105,
    rx: 9.5,
    ry: 9.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1854"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 146,
    width: 97,
    height: 106,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 146.5,
    y: 0.5,
    width: 96,
    height: 105,
    rx: 9.5,
    ry: 9.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1853"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 141,
    height: 106,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 0.5,
    y: 0.5,
    width: 140,
    height: 105,
    rx: 9.5,
    ry: 9.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NO_FRAGILITAT",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.03,67.599v8.4h-1.284l-4.632-5.688v5.688h-1.548v-8.4h1.284l4.632,5.688v-5.688h1.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.894,75.561c-.688-.371-1.228-.888-1.62-1.548-.392-.66-.588-1.397-.588-2.214s.196-1.554.588-2.214c.392-.66.932-1.176,1.62-1.548s1.46-.558,2.316-.558,1.628.186,2.316.558c.688.372,1.228.886,1.62,1.542s.588,1.396.588,2.22-.196,1.564-.588,2.22c-.392.656-.932,1.171-1.62,1.542-.688.372-1.46.559-2.316.559s-1.628-.187-2.316-.559ZM39.722,74.374c.448-.252.8-.604,1.056-1.056.256-.452.384-.958.384-1.519s-.128-1.065-.384-1.518c-.256-.452-.608-.805-1.056-1.057-.448-.252-.952-.378-1.512-.378s-1.064.126-1.512.378c-.448.252-.8.604-1.056,1.057s-.384.958-.384,1.518.128,1.066.384,1.519.608.804,1.056,1.056c.448.252.952.378,1.512.378s1.064-.126,1.512-.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.262,68.908v2.556h4.056v1.32h-4.056v3.216h-1.56v-8.4h6.132v1.309h-4.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.842,76l-1.717-2.46c-.072.008-.18.012-.324.012h-1.895v2.448h-1.561v-8.4h3.456c.729,0,1.363.12,1.902.36.541.24.955.584,1.242,1.032s.432.979.432,1.596c0,.632-.154,1.176-.461,1.632-.309.456-.75.797-1.326,1.021l1.932,2.76h-1.68ZM60.278,69.351c-.352-.287-.869-.432-1.549-.432h-1.822v3.348h1.822c.68,0,1.197-.146,1.549-.438s.527-.706.527-1.242-.176-.948-.527-1.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.566,74.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM69.049,72.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.722,71.704h1.476v3.348c-.432.345-.936.608-1.512.792-.576.185-1.168.276-1.776.276-.855,0-1.628-.187-2.315-.559-.688-.371-1.229-.886-1.62-1.542-.393-.655-.588-1.396-.588-2.22s.195-1.563.588-2.22c.392-.656.934-1.17,1.626-1.542.691-.372,1.47-.558,2.334-.558.704,0,1.344.115,1.92.348s1.06.572,1.452,1.02l-.984.96c-.64-.64-1.412-.96-2.315-.96-.593,0-1.118.124-1.578.372s-.82.597-1.08,1.044c-.261.448-.391.96-.391,1.536,0,.561.13,1.064.391,1.512.26.448.62.801,1.08,1.057s.981.384,1.565.384c.656,0,1.232-.144,1.729-.432v-2.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.25,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.077,67.599h1.561v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.265,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.797,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.345,74.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM108.829,72.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.169,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FRAGILITAT_LLEU",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.694,68.908v2.556h4.056v1.32h-4.056v3.216h-1.56v-8.4h6.132v1.309h-4.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.274,76l-1.716-2.46c-.072.008-.18.012-.324.012h-1.896v2.448h-1.56v-8.4h3.456c.728,0,1.362.12,1.902.36s.954.584,1.242,1.032.432.979.432,1.596c0,.632-.154,1.176-.462,1.632-.308.456-.75.797-1.326,1.021l1.932,2.76h-1.68ZM172.71,69.351c-.352-.287-.868-.432-1.548-.432h-1.824v3.348h1.824c.68,0,1.196-.146,1.548-.438s.528-.706.528-1.242-.176-.948-.528-1.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.998,74.055h-4.2l-.828,1.944h-1.608l3.78-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM181.482,72.832l-1.584-3.672-1.572,3.672h3.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.153,71.704h1.476v3.348c-.432.345-.936.608-1.512.792-.576.185-1.168.276-1.776.276-.856,0-1.628-.187-2.316-.559-.688-.371-1.228-.886-1.62-1.542-.392-.655-.588-1.396-.588-2.22s.196-1.563.588-2.22c.392-.656.934-1.17,1.626-1.542.692-.372,1.47-.558,2.334-.558.704,0,1.344.115,1.919.348.576.232,1.061.572,1.453,1.02l-.984.96c-.641-.64-1.413-.96-2.316-.96-.592,0-1.118.124-1.578.372s-.82.597-1.08,1.044c-.26.448-.39.96-.39,1.536,0,.561.13,1.064.39,1.512.26.448.62.801,1.08,1.057s.982.384,1.566.384c.656,0,1.231-.144,1.728-.432v-2.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.682,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.509,67.599h1.561v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.697,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.229,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.777,74.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM221.261,72.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.602,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.186,82.599h1.56v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.374,82.599h1.56v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.862,89.692v1.308h-6.3v-8.4h6.132v1.309h-4.572v2.184h4.056v1.284h-4.056v2.316h4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.502,90.141c-.648-.651-.972-1.586-.972-2.802v-4.74h1.56v4.681c0,1.647.712,2.472,2.136,2.472,1.416,0,2.124-.824,2.124-2.472v-4.681h1.536v4.74c0,1.216-.322,2.15-.966,2.802-.645.652-1.546.979-2.706.979s-2.064-.326-2.712-.979Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FRAGILITAT_INTERM\\xC8DIA",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.694,68.908v2.556h4.056v1.32h-4.056v3.216h-1.561v-8.4h6.132v1.309h-4.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.274,76l-1.716-2.46c-.072.008-.181.012-.324.012h-1.896v2.448h-1.56v-8.4h3.456c.728,0,1.361.12,1.901.36s.954.584,1.242,1.032.433.979.433,1.596c0,.632-.154,1.176-.462,1.632-.309.456-.75.797-1.326,1.021l1.932,2.76h-1.68ZM274.71,69.351c-.352-.287-.868-.432-1.548-.432h-1.824v3.348h1.824c.68,0,1.196-.146,1.548-.438.353-.292.528-.706.528-1.242s-.176-.948-.528-1.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.998,74.055h-4.2l-.828,1.944h-1.607l3.78-8.4h1.535l3.792,8.4h-1.632l-.84-1.944ZM283.482,72.832l-1.584-3.672-1.572,3.672h3.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.153,71.704h1.476v3.348c-.432.345-.936.608-1.512.792-.575.185-1.168.276-1.775.276-.856,0-1.628-.187-2.316-.559-.688-.371-1.228-.886-1.619-1.542-.393-.655-.589-1.396-.589-2.22s.196-1.563.589-2.22c.392-.656.934-1.17,1.626-1.542.691-.372,1.47-.558,2.334-.558.703,0,1.344.115,1.919.348.576.232,1.061.572,1.453,1.02l-.984.96c-.641-.64-1.412-.96-2.316-.96-.592,0-1.118.124-1.578.372s-.819.597-1.079,1.044c-.261.448-.391.96-.391,1.536,0,.561.13,1.064.391,1.512.26.448.619.801,1.079,1.057s.982.384,1.566.384c.656,0,1.231-.144,1.728-.432v-2.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.682,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.509,67.599h1.561v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.697,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.229,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.777,74.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM323.261,72.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.602,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.222,82.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.514,82.599v8.4h-1.284l-4.632-5.688v5.688h-1.548v-8.4h1.284l4.632,5.688v-5.688h1.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.474,83.92h-2.784v-1.32h7.128v1.32h-2.783v7.08h-1.561v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.294,89.692v1.308h-6.301v-8.4h6.132v1.309h-4.571v2.184h4.056v1.284h-4.056v2.316h4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.529,91l-1.716-2.46c-.072.008-.181.012-.324.012h-1.896v2.448h-1.561v-8.4h3.456c.728,0,1.362.12,1.902.36s.954.584,1.241,1.032c.288.448.433.979.433,1.596,0,.632-.154,1.176-.462,1.632-.309.456-.75.797-1.326,1.021l1.932,2.76h-1.68ZM291.965,84.351c-.352-.287-.868-.432-1.548-.432h-1.823v3.348h1.823c.68,0,1.196-.146,1.548-.438.353-.292.528-.706.528-1.242s-.176-.948-.528-1.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.521,91l-.012-5.568-2.76,4.608h-.696l-2.76-4.536v5.496h-1.488v-8.4h1.284l3.336,5.568,3.276-5.568h1.283l.013,8.4h-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.564,89.692v1.308h-6.3v-8.4h6.132v1.309h-4.571v2.184h4.056v1.284h-4.056v2.316h4.739ZM307.973,80.272h1.764l1.62,1.644h-1.296l-2.088-1.644Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.305,82.599h3.672c.896,0,1.692.175,2.389.522.695.348,1.235.84,1.619,1.476.385.637.576,1.37.576,2.202s-.191,1.566-.576,2.202c-.384.636-.924,1.128-1.619,1.476-.696.349-1.492.522-2.389.522h-3.672v-8.4ZM318.904,89.679c.616,0,1.158-.117,1.626-.354.469-.236.828-.572,1.08-1.008.252-.437.378-.942.378-1.519s-.126-1.082-.378-1.518c-.252-.437-.611-.772-1.08-1.008-.468-.236-1.01-.354-1.626-.354h-2.039v5.76h2.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.217,82.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.493,89.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM333.977,87.832l-1.584-3.672-1.571,3.672h3.155Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FRAGILITAT_AVAN\\xC7ADA",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.694,68.908v2.556h4.056v1.32h-4.056v3.216h-1.561v-8.4h6.132v1.309h-4.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.274,76l-1.716-2.46c-.072.008-.181.012-.324.012h-1.896v2.448h-1.56v-8.4h3.456c.728,0,1.361.12,1.901.36s.954.584,1.242,1.032.433.979.433,1.596c0,.632-.154,1.176-.462,1.632-.309.456-.75.797-1.326,1.021l1.932,2.76h-1.68ZM397.71,69.351c-.352-.287-.868-.432-1.548-.432h-1.824v3.348h1.824c.68,0,1.196-.146,1.548-.438.353-.292.528-.706.528-1.242s-.176-.948-.528-1.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.998,74.055h-4.2l-.828,1.944h-1.607l3.78-8.4h1.535l3.792,8.4h-1.632l-.84-1.944ZM406.482,72.832l-1.584-3.672-1.572,3.672h3.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.153,71.704h1.476v3.348c-.432.345-.936.608-1.512.792-.575.185-1.168.276-1.775.276-.856,0-1.628-.187-2.316-.559-.688-.371-1.228-.886-1.619-1.542-.393-.655-.589-1.396-.589-2.22s.196-1.563.589-2.22c.392-.656.934-1.17,1.626-1.542.691-.372,1.47-.558,2.334-.558.703,0,1.344.115,1.919.348.576.232,1.061.572,1.453,1.02l-.984.96c-.641-.64-1.412-.96-2.316-.96-.592,0-1.118.124-1.578.372s-.819.597-1.079,1.044c-.261.448-.391.96-.391,1.536,0,.561.13,1.064.391,1.512.26.448.619.801,1.079,1.057s.982.384,1.566.384c.656,0,1.231-.144,1.728-.432v-2.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.682,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.509,67.599h1.561v7.08h4.392v1.32h-5.952v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.697,67.599h1.561v8.4h-1.561v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.229,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.777,74.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM446.261,72.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.602,68.92h-2.784v-1.32h7.128v1.32h-2.784v7.08h-1.56v-7.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.643,89.055h-4.2l-.828,1.944h-1.608l3.78-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM390.126,87.832l-1.584-3.672-1.572,3.672h3.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.418,82.599l-3.66,8.4h-1.536l-3.672-8.4h1.692l2.796,6.48,2.82-6.48h1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.49,89.055h-4.2l-.828,1.944h-1.607l3.78-8.4h1.535l3.792,8.4h-1.632l-.84-1.944ZM406.975,87.832l-1.584-3.672-1.572,3.672h3.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.494,82.599v8.4h-1.284l-4.632-5.688v5.688h-1.548v-8.4h1.284l4.632,5.688v-5.688h1.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.34,90.561c-.684-.371-1.22-.886-1.607-1.542-.389-.655-.582-1.396-.582-2.22s.195-1.563.588-2.22c.392-.656.93-1.17,1.614-1.542.684-.372,1.449-.558,2.298-.558.688,0,1.315.119,1.884.359.567.24,1.048.588,1.439,1.044l-1.008.948c-.607-.656-1.355-.984-2.244-.984-.575,0-1.092.126-1.548.378s-.812.603-1.067,1.051c-.257.448-.385.956-.385,1.523s.128,1.076.385,1.524c.256.448.611.798,1.067,1.05s.973.378,1.548.378c.889,0,1.637-.332,2.244-.996l1.008.96c-.392.456-.874.804-1.445,1.044-.572.24-1.202.36-1.891.36-.848,0-1.613-.187-2.298-.559ZM422.97,93.484l.276-.708c.248.128.52.191.816.191.424,0,.636-.144.636-.432,0-.12-.053-.216-.156-.288s-.264-.108-.479-.108h-.372l.323-1.224h.816l-.168.672c.344.04.604.15.78.33.176.18.264.406.264.678,0,.344-.148.62-.444.828s-.691.312-1.188.312c-.433,0-.8-.084-1.104-.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.742,89.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM434.226,87.832l-1.584-3.672-1.571,3.672h3.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.282,82.599h3.672c.896,0,1.692.175,2.389.522.695.348,1.235.84,1.619,1.476.385.637.576,1.37.576,2.202s-.191,1.566-.576,2.202c-.384.636-.924,1.128-1.619,1.476-.696.349-1.492.522-2.389.522h-3.672v-8.4ZM441.882,89.679c.616,0,1.158-.117,1.626-.354.469-.236.828-.572,1.08-1.008.252-.437.378-.942.378-1.519s-.126-1.082-.378-1.518c-.252-.437-.611-.772-1.08-1.008-.468-.236-1.01-.354-1.626-.354h-2.039v5.76h2.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.522,89.055h-4.2l-.828,1.944h-1.607l3.779-8.4h1.536l3.792,8.4h-1.632l-.84-1.944ZM453.006,87.832l-1.584-3.672-1.571,3.672h3.155Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main_lines"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53",
    className: "st2",
    x1: 7.5,
    y1: 31.5,
    x2: 7.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-2",
    className: "st2",
    x1: 75.5,
    y1: 31.5,
    x2: 75.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-3",
    className: "st2",
    x1: 143.5,
    y1: 31.5,
    x2: 143.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-4",
    className: "st2",
    x1: 211.5,
    y1: 31.5,
    x2: 211.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-5",
    className: "st2",
    x1: 279.5,
    y1: 31.5,
    x2: 279.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-6",
    className: "st2",
    x1: 347.5,
    y1: 31.5,
    x2: 347.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-7",
    className: "st2",
    x1: 415.5,
    y1: 31.5,
    x2: 415.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53-8",
    className: "st2",
    x1: 483.5,
    y1: 31.5,
    x2: 483.5,
    y2: 44.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "not_mai_lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54",
    className: "st2",
    x1: 13.5,
    y1: 40.5,
    x2: 13.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-2",
    className: "st2",
    x1: 20.5,
    y1: 40.5,
    x2: 20.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-3",
    className: "st2",
    x1: 27.5,
    y1: 40.5,
    x2: 27.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-4",
    className: "st2",
    x1: 34.5,
    y1: 40.5,
    x2: 34.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-5",
    className: "st2",
    x1: 41.5,
    y1: 38.5,
    x2: 41.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-6",
    className: "st2",
    x1: 48.5,
    y1: 40.5,
    x2: 48.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-7",
    className: "st2",
    x1: 55.5,
    y1: 40.5,
    x2: 55.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-8",
    className: "st2",
    x1: 62.5,
    y1: 40.5,
    x2: 62.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-9",
    className: "st2",
    x1: 69.5,
    y1: 40.5,
    x2: 69.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-10",
    className: "st2",
    x1: 81.5,
    y1: 40.5,
    x2: 81.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-11",
    className: "st2",
    x1: 88.5,
    y1: 40.5,
    x2: 88.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-12",
    className: "st2",
    x1: 95.5,
    y1: 40.5,
    x2: 95.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-13",
    className: "st2",
    x1: 102.5,
    y1: 40.5,
    x2: 102.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-14",
    className: "st2",
    x1: 109.5,
    y1: 38.5,
    x2: 109.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-15",
    className: "st2",
    x1: 116.5,
    y1: 40.5,
    x2: 116.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-16",
    className: "st2",
    x1: 123.5,
    y1: 40.5,
    x2: 123.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-17",
    className: "st2",
    x1: 130.5,
    y1: 40.5,
    x2: 130.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-18",
    className: "st2",
    x1: 137.5,
    y1: 40.5,
    x2: 137.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-19",
    className: "st2",
    x1: 149.5,
    y1: 40.5,
    x2: 149.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-20",
    className: "st2",
    x1: 156.5,
    y1: 40.5,
    x2: 156.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-21",
    className: "st2",
    x1: 163.5,
    y1: 40.5,
    x2: 163.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-22",
    className: "st2",
    x1: 170.5,
    y1: 40.5,
    x2: 170.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-23",
    className: "st2",
    x1: 177.5,
    y1: 38.5,
    x2: 177.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-24",
    className: "st2",
    x1: 184.5,
    y1: 40.5,
    x2: 184.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-25",
    className: "st2",
    x1: 191.5,
    y1: 40.5,
    x2: 191.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-26",
    className: "st2",
    x1: 198.5,
    y1: 40.5,
    x2: 198.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-27",
    className: "st2",
    x1: 205.5,
    y1: 40.5,
    x2: 205.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-4"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-28",
    className: "st2",
    x1: 217.5,
    y1: 40.5,
    x2: 217.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-29",
    className: "st2",
    x1: 224.5,
    y1: 40.5,
    x2: 224.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-30",
    className: "st2",
    x1: 231.5,
    y1: 40.5,
    x2: 231.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-31",
    className: "st2",
    x1: 238.5,
    y1: 40.5,
    x2: 238.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-32",
    className: "st2",
    x1: 245.5,
    y1: 38.5,
    x2: 245.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-33",
    className: "st2",
    x1: 252.5,
    y1: 40.5,
    x2: 252.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-34",
    className: "st2",
    x1: 259.5,
    y1: 40.5,
    x2: 259.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-35",
    className: "st2",
    x1: 266.5,
    y1: 40.5,
    x2: 266.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-36",
    className: "st2",
    x1: 273.5,
    y1: 40.5,
    x2: 273.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-5"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-37",
    className: "st2",
    x1: 285.5,
    y1: 40.5,
    x2: 285.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-38",
    className: "st2",
    x1: 292.5,
    y1: 40.5,
    x2: 292.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-39",
    className: "st2",
    x1: 299.5,
    y1: 40.5,
    x2: 299.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-40",
    className: "st2",
    x1: 306.5,
    y1: 40.5,
    x2: 306.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-41",
    className: "st2",
    x1: 313.5,
    y1: 38.5,
    x2: 313.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-42",
    className: "st2",
    x1: 320.5,
    y1: 40.5,
    x2: 320.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-43",
    className: "st2",
    x1: 327.5,
    y1: 40.5,
    x2: 327.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-44",
    className: "st2",
    x1: 334.5,
    y1: 40.5,
    x2: 334.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-45",
    className: "st2",
    x1: 341.5,
    y1: 40.5,
    x2: 341.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-6"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-46",
    className: "st2",
    x1: 353.5,
    y1: 40.5,
    x2: 353.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-47",
    className: "st2",
    x1: 360.5,
    y1: 40.5,
    x2: 360.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-48",
    className: "st2",
    x1: 367.5,
    y1: 40.5,
    x2: 367.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-49",
    className: "st2",
    x1: 374.5,
    y1: 40.5,
    x2: 374.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-50",
    className: "st2",
    x1: 381.5,
    y1: 38.5,
    x2: 381.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-51",
    className: "st2",
    x1: 388.5,
    y1: 40.5,
    x2: 388.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-52",
    className: "st2",
    x1: 395.5,
    y1: 40.5,
    x2: 395.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-53",
    className: "st2",
    x1: 402.5,
    y1: 40.5,
    x2: 402.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-54",
    className: "st2",
    x1: 409.5,
    y1: 40.5,
    x2: 409.5,
    y2: 46.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-55",
    className: "st2",
    x1: 421.5,
    y1: 40.5,
    x2: 421.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-56",
    className: "st2",
    x1: 428.5,
    y1: 40.5,
    x2: 428.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-57",
    className: "st2",
    x1: 435.5,
    y1: 40.5,
    x2: 435.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-58",
    className: "st2",
    x1: 442.5,
    y1: 40.5,
    x2: 442.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-59",
    className: "st2",
    x1: 449.5,
    y1: 38.5,
    x2: 449.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-60",
    className: "st2",
    x1: 456.5,
    y1: 40.5,
    x2: 456.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-61",
    className: "st2",
    x1: 463.5,
    y1: 40.5,
    x2: 463.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-62",
    className: "st2",
    x1: 470.5,
    y1: 40.5,
    x2: 470.5,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54-63",
    className: "st2",
    x1: 477.5,
    y1: 40.5,
    x2: 477.5,
    y2: 46.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Main_numbers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.266,24.556c-.508-.344-.904-.838-1.188-1.481-.284-.645-.426-1.402-.426-2.274s.142-1.63.426-2.273c.284-.645.68-1.139,1.188-1.482.508-.344,1.086-.516,1.734-.516s1.226.172,1.734.516c.508.344.906.838,1.194,1.482.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.686,1.138-1.194,1.481-.508.345-1.086.517-1.734.517s-1.226-.172-1.734-.517ZM11.29,23.872c.372-.271.662-.668.87-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.87-1.188-.372-.271-.802-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_1",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.966,24.556c-.508-.344-.904-.838-1.188-1.481-.284-.645-.426-1.402-.426-2.274s.142-1.63.426-2.273c.284-.645.68-1.139,1.188-1.482.508-.344,1.086-.516,1.734-.516s1.226.172,1.734.516c.508.344.906.838,1.194,1.482.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.686,1.138-1.194,1.481-.508.345-1.086.517-1.734.517s-1.226-.172-1.734-.517ZM73.99,23.872c.372-.271.662-.668.87-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.87-1.188-.372-.271-.802-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.28,23.939c.12.124.18.277.18.462,0,.096-.014.199-.042.312s-.07.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222-.08-.108-.12-.238-.12-.39,0-.185.06-.338.18-.462s.272-.187.456-.187.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.892,16.6v8.4h-.864v-7.632h-1.98v-.769h2.844Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_2",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.592,24.556c-.508-.344-.904-.838-1.188-1.481-.284-.645-.426-1.402-.426-2.274s.142-1.63.426-2.273c.284-.645.68-1.139,1.188-1.482.508-.344,1.086-.516,1.734-.516s1.226.172,1.734.516c.508.344.906.838,1.194,1.482.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.686,1.138-1.194,1.481-.508.345-1.086.517-1.734.517s-1.226-.172-1.734-.517ZM140.616,23.872c.372-.271.662-.668.87-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.87-1.188-.372-.271-.802-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.906,23.939c.12.124.18.277.18.462,0,.096-.014.199-.042.312s-.07.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222-.08-.108-.12-.238-.12-.39,0-.185.06-.338.18-.462s.272-.187.456-.187.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.189,24.233v.768h-5.892v-.612l3.492-3.42c.44-.432.738-.806.894-1.122.156-.315.234-.634.234-.954,0-.495-.17-.882-.51-1.157-.34-.276-.826-.414-1.458-.414-.984,0-1.748.312-2.292.936l-.612-.528c.328-.384.746-.68,1.254-.888.508-.208,1.082-.312,1.722-.312.856,0,1.534.202,2.034.605.5.404.75.958.75,1.662,0,.432-.096.849-.288,1.248-.192.4-.556.86-1.092,1.38l-2.856,2.809h4.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_3",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.616,24.556c-.508-.344-.904-.838-1.188-1.481-.283-.645-.426-1.402-.426-2.274s.143-1.63.426-2.273c.284-.645.681-1.139,1.188-1.482s1.086-.516,1.734-.516,1.226.172,1.733.516.906.838,1.194,1.482c.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.687,1.138-1.194,1.481-.508.345-1.086.517-1.733.517s-1.227-.172-1.734-.517ZM208.641,23.872c.371-.271.661-.668.869-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.869-1.188-.372-.271-.803-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.931,23.939c.119.124.18.277.18.462,0,.096-.015.199-.042.312-.028.112-.07.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222s-.12-.238-.12-.39c0-.185.061-.338.181-.462s.271-.187.456-.187c.184,0,.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.344,20.914c.46.428.69.986.69,1.674,0,.48-.116.906-.349,1.278-.231.372-.576.666-1.032.882-.455.216-1.012.324-1.668.324-.607,0-1.182-.098-1.722-.294s-.974-.458-1.302-.786l.42-.685c.28.288.652.522,1.116.702.464.181.96.271,1.487.271.688,0,1.221-.15,1.597-.45s.563-.714.563-1.242c0-.52-.188-.928-.563-1.224s-.944-.444-1.704-.444h-.601v-.636l2.328-2.916h-4.296v-.769h5.4v.612l-2.376,2.988c.88.048,1.55.286,2.01.714Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_4",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.172,24.556c-.508-.344-.904-.838-1.188-1.481-.283-.645-.426-1.402-.426-2.274s.143-1.63.426-2.273c.284-.645.681-1.139,1.188-1.482s1.086-.516,1.734-.516,1.226.172,1.733.516.906.838,1.194,1.482c.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.687,1.138-1.194,1.481-.508.345-1.086.517-1.733.517s-1.227-.172-1.734-.517ZM276.196,23.872c.371-.271.661-.668.869-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.869-1.188-.372-.271-.803-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.486,23.939c.119.124.18.277.18.462,0,.096-.015.199-.042.312-.028.112-.07.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222s-.12-.238-.12-.39c0-.185.061-.338.181-.462s.271-.187.456-.187c.184,0,.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.898,22.792h-1.681v2.208h-.863v-2.208h-4.74v-.624l4.452-5.568h.96l-4.296,5.425h3.647v-1.944h.84v1.944h1.681v.768Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_5",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.664,24.556c-.508-.344-.904-.838-1.188-1.481-.283-.645-.426-1.402-.426-2.274s.143-1.63.426-2.273c.284-.645.681-1.139,1.188-1.482s1.086-.516,1.734-.516,1.226.172,1.733.516.906.838,1.194,1.482c.288.644.432,1.401.432,2.273s-.144,1.63-.432,2.274c-.288.644-.687,1.138-1.194,1.481-.508.345-1.086.517-1.733.517s-1.227-.172-1.734-.517ZM344.688,23.872c.371-.271.661-.668.869-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.869-1.188-.372-.271-.803-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.979,23.939c.119.124.18.277.18.462,0,.096-.015.199-.042.312-.028.112-.07.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222s-.12-.238-.12-.39c0-.185.061-.338.181-.462s.271-.187.456-.187c.184,0,.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.272,20.698c.556.436.834,1.046.834,1.83,0,.487-.114.924-.343,1.308-.228.384-.569.687-1.025.906s-1.017.33-1.681.33c-.6,0-1.17-.098-1.71-.294s-.974-.458-1.302-.786l.42-.685c.28.288.648.522,1.104.702.456.181.947.271,1.476.271.696,0,1.234-.156,1.614-.469.38-.312.57-.728.57-1.247,0-.576-.215-1.013-.643-1.309s-1.15-.444-2.166-.444h-1.788l.433-4.212h4.596v.769h-3.84l-.288,2.676h1.08c1.216,0,2.102.218,2.658.654Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_6",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.472,24.556c-.508-.344-.903-.838-1.188-1.481-.284-.645-.426-1.402-.426-2.274s.142-1.63.426-2.273c.284-.645.68-1.139,1.188-1.482.509-.344,1.087-.516,1.734-.516s1.226.172,1.734.516c.508.344.905.838,1.193,1.482.288.644.433,1.401.433,2.273s-.145,1.63-.433,2.274c-.288.644-.686,1.138-1.193,1.481-.509.345-1.086.517-1.734.517s-1.226-.172-1.734-.517ZM412.496,23.872c.372-.271.662-.668.87-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.87-1.188-.372-.271-.802-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.786,23.939c.12.124.18.277.18.462,0,.096-.014.199-.042.312-.027.112-.069.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222-.08-.108-.12-.238-.12-.39,0-.185.06-.338.18-.462s.272-.187.456-.187.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.032,20.284c.428.208.762.502,1.002.882s.36.822.36,1.326c0,.512-.124.964-.372,1.355-.248.393-.59.694-1.026.906-.436.212-.926.318-1.47.318-1.112,0-1.964-.366-2.556-1.099-.593-.731-.889-1.766-.889-3.102,0-.937.16-1.729.48-2.376.319-.648.768-1.138,1.344-1.47s1.248-.498,2.016-.498c.832,0,1.496.151,1.992.456l-.348.695c-.4-.264-.944-.396-1.632-.396-.929,0-1.656.294-2.185.882-.527.588-.792,1.442-.792,2.562,0,.2.013.429.036.685.208-.456.54-.811.996-1.062s.979-.378,1.572-.378c.552,0,1.042.104,1.47.312ZM422.973,23.842c.38-.332.569-.773.569-1.326s-.189-.991-.569-1.319c-.381-.328-.895-.492-1.542-.492-.425,0-.799.08-1.122.24-.324.16-.578.38-.763.659-.184.28-.275.593-.275.937,0,.32.086.616.258.888.172.272.426.492.762.66s.736.252,1.2.252c.607,0,1.102-.166,1.482-.498Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_7",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469.598,24.556c-.508-.344-.903-.838-1.188-1.481-.284-.645-.426-1.402-.426-2.274s.142-1.63.426-2.273c.284-.645.68-1.139,1.188-1.482.509-.344,1.087-.516,1.734-.516s1.226.172,1.734.516c.508.344.905.838,1.193,1.482.288.644.433,1.401.433,2.273s-.145,1.63-.433,2.274c-.288.644-.686,1.138-1.193,1.481-.509.345-1.086.517-1.734.517s-1.226-.172-1.734-.517ZM472.622,23.872c.372-.271.662-.668.87-1.188.208-.52.312-1.147.312-1.884s-.104-1.363-.312-1.884c-.208-.52-.498-.916-.87-1.188-.372-.271-.802-.407-1.29-.407s-.918.136-1.29.407c-.372.272-.662.669-.87,1.188-.208.521-.312,1.148-.312,1.884s.104,1.364.312,1.884c.208.521.498.917.87,1.188.372.272.802.408,1.29.408s.918-.136,1.29-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.912,23.939c.12.124.18.277.18.462,0,.096-.014.199-.042.312-.027.112-.069.24-.126.384l-.504,1.656h-.576l.408-1.74c-.128-.04-.232-.113-.312-.222-.08-.108-.12-.238-.12-.39,0-.185.06-.338.18-.462s.272-.187.456-.187.336.062.456.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.124,16.6v.612l-3.516,7.788h-.937l3.456-7.632h-4.32v1.572h-.852v-2.341h6.168Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Not_main_numbers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0_05",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.172,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987.338-.229.724-.345,1.156-.345s.817.115,1.156.345c.338.229.604.559.796.987.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.724.344-1.156.344s-.817-.114-1.156-.344ZM37.188,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.048,34.292c.08.083.12.186.12.308,0,.064-.009.134-.028.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.272-1.16c-.085-.026-.155-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.12-.308.08-.083.182-.124.304-.124s.224.041.304.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.988,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987.338-.229.724-.345,1.156-.345s.817.115,1.156.345c.338.229.604.559.796.987.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.724.344-1.156.344s-.817-.114-1.156-.344ZM44.004,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.452,32.132c.371.291.556.697.556,1.22,0,.326-.076.616-.228.872-.152.257-.38.458-.684.604-.304.146-.678.22-1.12.22-.4,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.736.468.304.12.632.18.984.18.464,0,.823-.104,1.076-.312s.38-.485.38-.832c0-.384-.143-.675-.428-.872-.286-.197-.767-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.56l-.192,1.784h.72c.811,0,1.401.146,1.772.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_15",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.38,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987.338-.229.724-.345,1.156-.345s.817.115,1.156.345c.338.229.604.559.796.987.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.724.344-1.156.344s-.817-.114-1.156-.344ZM105.396,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.256,34.292c.08.083.12.186.12.308,0,.064-.009.134-.028.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.272-1.16c-.085-.026-.155-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.12-.308.08-.083.182-.124.304-.124s.224.041.304.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.664,29.401v5.6h-.576v-5.088h-1.32v-.512h1.896Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.244,32.132c.371.291.556.697.556,1.22,0,.326-.076.616-.228.872-.152.257-.38.458-.684.604-.304.146-.678.22-1.12.22-.4,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.736.468.304.12.632.18.984.18.464,0,.823-.104,1.076-.312s.38-.485.38-.832c0-.384-.143-.675-.428-.872-.286-.197-.767-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.56l-.192,1.784h.72c.811,0,1.401.146,1.772.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_25",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.464,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987.338-.229.724-.345,1.156-.345s.817.115,1.156.345c.338.229.604.559.796.987.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.724.344-1.156.344s-.817-.114-1.156-.344ZM172.48,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.34,34.292c.08.083.12.186.12.308,0,.064-.009.134-.028.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.272-1.16c-.085-.026-.155-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.12-.308.08-.083.182-.124.304-.124s.224.041.304.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.196,34.489v.512h-3.928v-.408l2.328-2.28c.293-.287.492-.537.596-.747.104-.211.156-.423.156-.637,0-.33-.113-.588-.34-.771-.227-.185-.55-.276-.972-.276-.656,0-1.166.208-1.528.624l-.408-.352c.219-.256.497-.453.836-.593.339-.139.721-.208,1.148-.208.571,0,1.022.135,1.356.404s.5.639.5,1.108c0,.288-.064.565-.192.832s-.371.573-.728.92l-1.904,1.872h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.16,32.132c.371.291.556.697.556,1.22,0,.326-.076.616-.228.872-.152.257-.38.458-.684.604-.304.146-.678.22-1.12.22-.4,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.736.468.304.12.632.18.984.18.464,0,.823-.104,1.076-.312s.38-.485.38-.832c0-.384-.143-.675-.428-.872-.286-.197-.767-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.56l-.192,1.784h.72c.811,0,1.401.146,1.772.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_35",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.521,34.704c-.339-.229-.604-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.188-.429.453-.758.792-.987.338-.229.724-.345,1.155-.345s.817.115,1.156.345.604.559.796.987c.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.191.43-.457.759-.796.988s-.724.344-1.156.344-.817-.114-1.155-.344ZM240.536,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.611.091-.859.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.534.271.859.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.396,34.292c.08.083.119.186.119.308,0,.064-.009.134-.027.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.271-1.16c-.085-.026-.154-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.12-.308s.182-.124.304-.124c.123,0,.225.041.305.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.672,32.277c.307.285.46.657.46,1.115,0,.32-.077.604-.231.853-.155.248-.385.444-.688.588s-.675.216-1.112.216c-.405,0-.788-.065-1.147-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.435.348.744.468.309.12.64.18.991.18.459,0,.813-.1,1.064-.3s.376-.476.376-.828c0-.347-.125-.618-.376-.815s-.63-.296-1.136-.296h-.4v-.424l1.552-1.944h-2.863v-.512h3.6v.407l-1.584,1.992c.587.032,1.033.191,1.34.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.104,32.132c.37.291.556.697.556,1.22,0,.326-.076.616-.229.872-.151.257-.38.458-.684.604s-.678.22-1.12.22c-.399,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.735.468.305.12.633.18.984.18.464,0,.822-.104,1.076-.312.253-.208.38-.485.38-.832,0-.384-.143-.675-.428-.872-.286-.197-.768-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.561l-.191,1.784h.72c.811,0,1.401.146,1.772.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_45",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.2,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987s.724-.345,1.156-.345.817.115,1.156.345c.338.229.604.559.796.987.191.43.288.936.288,1.517s-.097,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.725.344-1.156.344s-.817-.114-1.156-.344ZM308.216,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.534-.272-.859-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.611-.09.859-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.076,34.292c.08.083.12.186.12.308,0,.064-.01.134-.028.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.272-1.16c-.086-.026-.155-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.119-.308.08-.083.182-.124.305-.124.122,0,.224.041.304.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.684,33.529h-1.119v1.472h-.576v-1.472h-3.16v-.416l2.968-3.712h.641l-2.864,3.615h2.432v-1.296h.561v1.296h1.119v.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.425,32.132c.37.291.556.697.556,1.22,0,.326-.076.616-.229.872-.151.257-.38.458-.684.604s-.678.22-1.12.22c-.399,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.735.468.305.12.633.18.984.18.464,0,.822-.104,1.076-.312.253-.208.38-.485.38-.832,0-.384-.143-.675-.428-.872-.286-.197-.768-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.561l-.191,1.784h.72c.811,0,1.401.146,1.772.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_55",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.532,34.704c-.339-.229-.604-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.188-.429.453-.758.792-.987.338-.229.724-.345,1.155-.345s.817.115,1.156.345.604.559.796.987c.192.43.288.936.288,1.517s-.096,1.087-.288,1.516c-.191.43-.457.759-.796.988s-.724.344-1.156.344-.817-.114-1.155-.344ZM376.548,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.535-.272-.86-.272s-.611.091-.859.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.534.271.859.271.612-.09.86-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.408,34.292c.08.083.119.186.119.308,0,.064-.009.134-.027.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.271-1.16c-.085-.026-.154-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.12-.308s.182-.124.304-.124c.123,0,.225.041.305.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.604,32.132c.371.291.556.697.556,1.22,0,.326-.075.616-.228.872-.152.257-.38.458-.684.604-.305.146-.678.22-1.12.22-.4,0-.78-.065-1.141-.196-.359-.13-.649-.305-.868-.523l.28-.456c.187.192.433.348.736.468s.632.18.983.18c.465,0,.823-.104,1.076-.312.254-.208.38-.485.38-.832,0-.384-.143-.675-.428-.872s-.767-.296-1.444-.296h-1.191l.288-2.808h3.063v.512h-2.56l-.192,1.784h.721c.811,0,1.4.146,1.771.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.092,32.132c.371.291.556.697.556,1.22,0,.326-.075.616-.228.872-.152.257-.38.458-.684.604-.305.146-.678.22-1.12.22-.4,0-.78-.065-1.141-.196-.359-.13-.649-.305-.868-.523l.28-.456c.187.192.433.348.736.468s.632.18.983.18c.465,0,.823-.104,1.076-.312.254-.208.38-.485.38-.832,0-.384-.143-.675-.428-.872s-.767-.296-1.444-.296h-1.191l.288-2.808h3.063v.512h-2.56l-.192,1.784h.721c.811,0,1.4.146,1.771.436Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0_65",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.384,34.704c-.339-.229-.603-.559-.792-.988-.189-.429-.284-.935-.284-1.516s.095-1.087.284-1.517c.189-.429.453-.758.792-.987s.724-.345,1.156-.345.817.115,1.156.345c.338.229.604.559.796.987.191.43.288.936.288,1.517s-.097,1.087-.288,1.516c-.192.43-.458.759-.796.988-.339.229-.725.344-1.156.344s-.817-.114-1.156-.344ZM444.399,34.248c.248-.182.441-.445.58-.792s.208-.766.208-1.256-.069-.909-.208-1.256-.332-.611-.58-.792c-.248-.182-.534-.272-.859-.272s-.612.091-.86.272c-.248.181-.441.445-.58.792s-.208.765-.208,1.256.069.909.208,1.256.332.61.58.792.535.271.86.271.611-.09.859-.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.26,34.292c.08.083.12.186.12.308,0,.064-.01.134-.028.208-.019.075-.047.16-.084.257l-.336,1.104h-.384l.272-1.16c-.086-.026-.155-.076-.208-.147-.054-.072-.08-.159-.08-.261,0-.122.04-.225.119-.308.08-.083.182-.124.305-.124.122,0,.224.041.304.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.424,31.857c.285.139.508.334.668.588.16.253.24.548.24.884,0,.341-.083.643-.248.904-.166.261-.394.462-.685.604-.29.142-.617.212-.979.212-.741,0-1.31-.244-1.704-.731-.395-.488-.592-1.178-.592-2.068,0-.624.106-1.152.319-1.584.214-.432.513-.759.896-.98.384-.221.832-.332,1.344-.332.555,0,.997.102,1.328.305l-.232.464c-.267-.176-.629-.264-1.088-.264-.618,0-1.104.195-1.456.588-.352.392-.527.961-.527,1.708,0,.133.008.285.023.456.139-.305.36-.54.664-.708.305-.168.653-.252,1.048-.252.368,0,.695.069.98.208ZM451.384,34.228c.253-.221.38-.516.38-.884s-.127-.661-.38-.88-.596-.328-1.028-.328c-.282,0-.531.054-.748.16-.216.106-.385.254-.508.44s-.184.395-.184.624c0,.213.057.41.172.592.114.182.284.328.508.439.224.112.49.168.8.168.405,0,.735-.11.988-.332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.24,32.132c.37.291.556.697.556,1.22,0,.326-.076.616-.229.872-.151.257-.38.458-.684.604s-.678.22-1.12.22c-.399,0-.78-.065-1.14-.196-.36-.13-.649-.305-.868-.523l.28-.456c.187.192.432.348.735.468.305.12.633.18.984.18.464,0,.822-.104,1.076-.312.253-.208.38-.485.38-.832,0-.384-.143-.675-.428-.872-.286-.197-.768-.296-1.444-.296h-1.192l.288-2.808h3.064v.512h-2.561l-.191,1.784h.72c.811,0,1.401.146,1.772.436Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalaVig);
export default __webpack_public_path__ + "static/media/escala VIG.be7e69baa076b1e6bdfc797c6eab16a9.svg";
export { ForwardRef as ReactComponent };